module.exports = __webpack_public_path__ + "static/media/dry-fruit.0544c950.jpg";